import api, { getAxiosBaseUrl } from "./axios";

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

function normalizeAxiosError(error) {
  const status = error?.response?.status || 0;
  const data = error?.response?.data || null;

  const message =
    data?.message ||
    data?.error ||
    error?.message ||
    "Error de conexión con el servidor";

  return new ApiError(message, status, data);
}

export async function apiRequest(path, options = {}) {
  try {
    const {
      method = "GET",
      body,
      headers,
      params,
      signal,
      ...restOptions
    } = options;

    const response = await api.request({
      url: path,
      method,
      data: body,
      headers,
      params,
      signal,
      ...restOptions,
    });

    return response.data;
  } catch (error) {
    throw normalizeAxiosError(error);
  }
}

export async function apiRequestFirst(paths, options = {}) {
  const list = Array.isArray(paths) ? paths : [paths];
  let lastError = null;

  for (const path of list) {
    try {
      return await apiRequest(path, options);
    } catch (error) {
      lastError = error;

      // Solo prueba la siguiente ruta cuando la actual no existe.
      if (error?.status !== 404) {
        throw error;
      }
    }
  }

  throw lastError || new ApiError("Ruta no encontrada", 404, null);
}

export function getApiBaseUrl() {
  return getAxiosBaseUrl();
}
